import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-linkdelink',
  templateUrl: './linkdelink.component.html',
  styleUrls: ['./linkdelink.component.css']
})
export class LinkdelinkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
